import { Injectable } from "@angular/core";
import { HttpmethodsService } from "src/app/demo/service/httpmethods.service";

export interface NavigationItem {
  id: string;
  title: string;
  type: "item" | "collapse" | "group";
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}
export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}
var privilegeData = JSON.parse(localStorage.getItem("privilegeData"));
if (!privilegeData) {
  privilegeData = {
    roleSettingRead: false,
    roleSettingWrite: false,

    courseSettingRead: false,
    courseSettingWrite: false,

    followupSettingRead: false,
    followupSettingWrite: false,

    paymentSettingRead: false,
    paymentSettingWrite: false,

    sourceOfLeadSettingRead: false,
    sourceOfLeadSettingWrite: false,

    expenseSettingRead: false,
    expenseSettingWrite: false,

    classSettingRead: false,
    classSettingWrite: false,

    branchSettingRead: false,
    branchSettingWrite: false,

    staffSettingRead: false,
    staffSettingWrite: false,

    privilegeSettingRead: false,
    privilegeSettingWrite: false,

    batchSettingRead: false,
    batchSettingWrite: false,

    expenseCategorySettingRead: false,
    expenseCategorySettingWrite: false,

    dashboardFullAccess: false,

    leadDisplyShowWithoutAdmin: false,

    admissionDisplyShowWithoutAdmin: false,

    generateExpense: false,

    performanceReportRead: false,
    performanceReportFullAccess: false,

    expenseReportRead: false,
    expenseReportFullAccess: false,

    followupCallReport: false,
    followupCallReportFullAccess: false,

    installmentViewReport: false,
    installmentViewReportFullAccess: false,

    leadaAndAdmissionTransferredReport: false,
    leadaAndAdmissionTransferredReportFullAccess: false,

    notificationTodayFollowupCall: false,
    notificationPendingFollowupCall: false,
    notificationLeadTransfer: false,
    notificationTodayFeeCall: false,
    notificationPendingFeeCall: false,
  };
}
var NavigationItems = [
  {
    id: "navigation",
    title: "Navigation",
    type: "group",
    icon: "feather icon-monitor",
    children: [
      {
        id: "dashboard",
        title: "Dashboard",
        type: "item",
        url: "/dashboard/default",
        icon: "feather icon-home",
        classes: "nav-item",
      },
      {
        id: "usersetting",
        title: "User Setting",
        type: "item",
        url: "/basic/usersetting",
        hidden: true,
      },
    ],
  },
  {
    id: "ui-element",
    title: "Admin Settings",
    type: "group",
    icon: "feather icon-layers",
    children: [
      {
        id: "basic",
        title: "Admin Settings ",
        type: "collapse",
        icon: "feather icon-settings",
        hidden:
          !privilegeData.classSettingRead &&
          !privilegeData.branchSettingRead &&
          !privilegeData.roleSettingRead &&
          !privilegeData.staffSettingRead &&
          !privilegeData.privilegeSettingRead &&
          !privilegeData.courseSettingRead &&
          !privilegeData.batchSettingRead &&
          !privilegeData.followupSettingRead &&
          !privilegeData.paymentSettingRead &&
          !privilegeData.sourceOfLeadSettingRead &&
          !privilegeData.expenseSettingRead &&
          !privilegeData.expenseCategorySettingRead,
        children: [
          {
            id: "classmaster",
            title: "Class Setting",
            type: "item",
            url: "/basic/classmaster",
            hidden: !privilegeData.classSettingRead,
          },
          {
            id: "branchmaster",
            title: "Branch Setting",
            type: "item",
            url: "/basic/branchmaster",
            hidden: !privilegeData.branchSettingRead,
          },
          {
            id: "rolemaster",
            title: "Role Setting",
            type: "item",
            url: "/basic/rolemaster",
            hidden: !privilegeData.roleSettingRead,
          },
          {
            id: "staffmaster",
            title: "Staff Setting",
            type: "item",
            url: "/basic/staffmaster",
            hidden: !privilegeData.staffSettingRead,
          },
          {
            id: "privilegemaster",
            title: "Privilege Setting",
            type: "item",
            url: "/basic/privilegemaster",
            hidden: !privilegeData.privilegeSettingRead,
          },
          {
            id: "coursemaster",
            title: "Course Setting",
            type: "item",
            url: "/basic/coursemaster",
            hidden: !privilegeData.courseSettingRead,
          },
          {
            id: "batchmaster",
            title: "Batch Setting",
            type: "item",
            url: "/basic/batchmaster",
            hidden: !privilegeData.batchSettingRead,
          },
          {
            id: "followupmaster",
            title: "Followup Setting",
            type: "item",
            url: "/basic/followupmaster",
            hidden: !privilegeData.followupSettingRead,
          },
          {
            id: "paymentmaster",
            title: "Payment Setting",
            type: "item",
            url: "/basic/paymentmaster",
            hidden: !privilegeData.paymentSettingRead,
          },
          {
            id: "sourceleadMaster",
            title: "Source Lead  Setting",
            type: "item",
            url: "/basic/sourceleadmaster",
            hidden: !privilegeData.sourceOfLeadSettingRead,
          },
          {
            id: "expensecategorymaster",
            title: "Expense Category Setting",
            type: "item",
            url: "/basic/expensecategorymaster",
            hidden: !privilegeData.expenseCategorySettingRead,
          },
          {
            id: "expensemaster",
            title: "Expense Type Setting",
            type: "item",
            url: "/basic/expensemaster",
            hidden: !privilegeData.expenseSettingRead,
          },
          {
            id: "gallerymaster",
            title: "Gallery Master",
            type: "item",
            url: "/basic/gallerymaster",
            hidden: false,
          },
        ],
      },
      {
        id: "leadmaster",
        title: "Create Lead",
        type: "item",
        url: "/basic/leadmaster",
        icon: "feather icon-plus-circle",
        classes: "nav-item",
      },
      {
        id: "leaddisplay",
        title: "Display Lead",
        type: "item",
        url: "/basic/leaddisplay",
        icon: "feather icon-file-plus",
        classes: "nav-item",
      },
      {
        id: "leadtransfer",
        title: "Lead Transfer",
        type: "item",
        url: "/basic/leadtransfer",
        hidden: true,
        icon: "feather icon-file-plus",
        classes: "nav-item",
      },
      {
        id: "readmission",
        title: "Readmission",
        type: "item",
        url: "/basic/readmission",
        hidden: true,
        icon: "feather icon-file-plus",
        classes: "nav-item",
      },
      {
        id: "leadwisefollowup",
        title: "Followup Lead",
        type: "item",
        url: "/basic/leadwisefollowup",
        hidden: true,
        icon: "feather icon-file-plus",
        classes: "nav-item",
      },
      {
        id: "leadwisefollowupdisplay",
        title: "Followup Lead",
        type: "item",
        url: "/basic/leadwisefollowupdisplay",
        hidden: true,
        icon: "feather icon-file-plus",
        classes: "nav-item",
      },
      {
        id: "todaypendinglead",
        title: "Todays Followup Lead",
        type: "item",
        url: "/basic/todaypendinglead",
        hidden: true,
        icon: "feather icon-file-plus",
        classes: "nav-item",
      },
      {
        id: "pendinglead",
        title: "Pending Followup Lead",
        type: "item",
        url: "/basic/pendinglead",
        hidden: true,
        icon: "feather icon-file-plus",
        classes: "nav-item",
      },
      {
        id: "leadtransfershow",
        title: "Transfer Lead Show",
        type: "item",
        url: "/basic/leadtransfershow",
        hidden: true,
        icon: "feather icon-file-plus",
        classes: "nav-item",
      },
      {
        id: "admissiondisplay",
        title: "Display Admission",
        type: "item",
        url: "/basic/admissiondisplay",
        icon: "feather icon-box",
        classes: "nav-item",
      },
      {
        id: "payinstallments",
        title: "Pay Installments",
        type: "item",
        url: "/basic/payinstallments",
        hidden: true,
        icon: "feather icon-box",
        classes: "nav-item",
      },
      {
        id: "updatebranchandbatch",
        title: "Update Branch & Batch",
        type: "item",
        url: "/basic/updatebranchandbatch",
        hidden: true,
        icon: "feather icon-box",
        classes: "nav-item",
      },
      {
        id: "dailypaymentreminder",
        title: "Pending Installment Information",
        type: "item",
        url: "/basic/dailypaymentreminder",
        hidden: true,
        icon: "feather icon-box",
        classes: "nav-item",
      },
      {
        id: "pendingpaymentreminder",
        title: "Todays Installment Information",
        type: "item",
        url: "/basic/pendingpaymentreminder",
        hidden: true,
        icon: "feather icon-box",
        classes: "nav-item",
      },
      {
        id: "generateexpense",
        title: "Generate Expense",
        type: "item",
        url: "/basic/generateexpense",
        icon: "feather icon-stop-circle",
        classes: "nav-item",
        hidden: !privilegeData.generateExpense,
      },
      {
        id: "basic",
        title: "Report",
        type: "collapse",
        icon: "feather icon-file-text",
        hidden:
          !privilegeData.performanceReportRead &&
          !privilegeData.expenseReportRead &&
          !privilegeData.followupCallReport &&
          !privilegeData.installmentViewReport &&
          !privilegeData.leadaAndAdmissionTransferredReport,
        children: [
          {
            id: "performancereport",
            title: "Performance Report",
            type: "item",
            url: "/basic/performancereport",
            hidden: !privilegeData.performanceReportRead,
          },
          {
            id: "expensereport",
            title: "Expense Report",
            type: "item",
            url: "/basic/expensereport",
            hidden: !privilegeData.expenseReportRead,
          },
          {
            id: "followupcallreport",
            title: "Folloup Report",
            type: "item",
            url: "/basic/followupcallreport",
            hidden: !privilegeData.followupCallReport,
          },
          {
            id: "viewinstallment",
            title: "Installment Report",
            type: "item",
            url: "/basic/viewinstallment",
            hidden: !privilegeData.installmentViewReport,
          },
          {
            id: "leadtransferred",
            title: "Lead Transferred Report",
            type: "item",
            url: "/basic/leadtransferred",
            hidden: !privilegeData.leadaAndAdmissionTransferredReport,
          },
        ],
      },
    ],
  },
];

@Injectable()
export class NavigationItem {
  public get() {
    return NavigationItems;
  }
}
